import angular from 'angular';
import { ssListItem } from 'app/components/global';
import healthResources from './healthResources';
import vendorResources from './vendorResources';
import otherResources from './otherResources';
import directive from './external-resources.directive';
import controller from './external-resources.controller';


export default angular.module('app.components.advisory.bcp.externalResources', [
  ssListItem,
  healthResources,
  vendorResources,
  otherResources,
])
  .directive('bcpExternalResources', directive)
  .controller('ExternalResourcesController', controller)
  .name;

console.log('app.components.advisory.bcp.externalResources created');
